import { Injectable } from "@angular/core";
import { ToolsService } from "../services/tools.service";


@Injectable({
    providedIn: 'root'
})
export class ExceptionsService{
    public tempFile: File;
    
    constructor(){}

    public saveTempFile(file){
        this.tempFile = file;
    }

    public getTempFile(){
        return this.tempFile;
    }
}